export default "__VITE_ASSET__BzTFbEYF__"